// removed by extract-text-webpack-plugin
module.exports = {"roundSocials":"RoundSocials-m__roundSocials___1CYqI","roundSocials_link":"RoundSocials-m__roundSocials_link___Snz-z","roundSocialsLink":"RoundSocials-m__roundSocials_link___Snz-z"};


//////////////////
// WEBPACK FOOTER
// ./components/roundSocials/RoundSocials.m.sass
// module id = jE6u
// module chunks = 0